import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PrototypeSettingsState {
  arePrototypesVisible: boolean;
  isCanvasVisible: boolean;
  setArePrototypesVisible: (arePrototypesVisible: boolean) => void;
  setIsCanvasVisible: (isCanvasVisible: boolean) => void;
}

/**
 * Dev-only runtime toggles for the prototype layer, persisted to localStorage.
 * Only consulted when the `VITE_PROTOTYPES_ENABLED` env gate is already on, so
 * production is unaffected. Both flags default to `true` to preserve current
 * dev behavior until a developer opts out via the b2b settings popover.
 */
export const usePrototypeSettingsStore = create<PrototypeSettingsState>()(
  persist(
    (set) => ({
      arePrototypesVisible: true,
      isCanvasVisible: true,
      setArePrototypesVisible: (arePrototypesVisible) => set({ arePrototypesVisible }),
      setIsCanvasVisible: (isCanvasVisible) => set({ isCanvasVisible }),
    }),
    { name: 'prototype-settings' },
  ),
);
